<template>
  <div class="events">
    <main-content
      right-sidebar="true"
    >
      <transition name="fade">
        <video-player 
          v-if="video"
          :source="video"
          @close="video = null"
        ></video-player>
      </transition>

      <tiny-slider v-bind="tinySliderOptions">
        <div class="events__background" v-for="(background, index) in activePage.backgroundContent" :key="background.image">
          <video :class="'video' + index" v-if="getSlideFileType(background.image) === 'video'" autoplay muted loop class="video" :src="`${$store.state.assetsPath}${background.image}`"></video>
          <img v-if="getSlideFileType(background.image) === 'image'" class="image" :src="`${$store.state.assetsPath}${background.image}`">
          <div v-if="background.heading[language.code] !== ''" class="events__background-heading" v-html="background.heading[language.code]"></div>
        </div>
      </tiny-slider>
      <transition name="fade-in-up">
        <div v-if="activePage.slides.length" class="events__event-slider">
          <div class="events__event-slider-controls">
            <div class="events__event-slider-prev"><fa :icon="['far', 'chevron-left']"/></div>
            <div class="events__event-slider-next"><fa :icon="['far', 'chevron-right']"/></div>
          </div>
          <!-- TODO destory the tiny slider -->
          <tiny-slider
            v-bind="carouselOptions"
            class="place__tiny-slider"
            ref="tinySlider"
            @dragMove="handleSliderDrag"
            @dragEnd="handleSliderDragEnd"
          >
            <div v-for="slide in activePage.slides" :key="slide._id">
              <div class="slide" :class="{ 'slide--reverse' : language.rtl }">
                <div class="slide__image-wrapper">
                  <img class="slide__image" :src="`${$store.state.assetsPath}${convertToThumbnail(slide.image)}`">
                  <div
                    v-if="isVideo(slide.image)"
                    class="slide__video-circle-wrapper"
                    :class="{ 'slide__video-circle-wrapper--active': slide.image === video }"
                  >
                    <fa :icon="['fad', 'play-circle']" @click="setVideo(slide.image)" />
                  </div>
                </div>
                <div class="slide__content">
                  <div class="slide__heading" v-html="slide.heading[language.code]"></div>
                  <div class="slide__description" v-html="slide.description[language.code]"></div>
                </div>
              </div>
            </div>       
          </tiny-slider>
        </div>
      </transition>      
    </main-content>
    <right-sidebar
      v-if="false"
      :logo="$store.state.config.sidebarLogo"
      :heading="activePage.label"
      :description="activePage.description"
      :navigation-items="sidebarNavigationItems"
    > 
    </right-sidebar>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MainContent from './MainContent'
import RightSidebar from './RightSidebar'
import TinySlider from 'vue-tiny-slider'
import VideoPlayer from '@/components/VideoPlayer'

export default {
  components: { MainContent, RightSidebar, TinySlider, VideoPlayer },

  data () {
    return {
      tinySliderOptions: {
        mode: "gallery",
        autoplay: true,
        autoplayTimeout: 7500,
        autoplayButton: false,
        autoplayButtonOutput: false,
        mouseDrag: false,
        controls: false,
        loop: true,
        items: 1,
        gutter: 0,
        nav: false,
        speed: 3000,
        animateIn: 'background--show',
        animateOut: 'background--hide',        
      },
      carouselOptions: {
        mouseDrag: true,
        controlsContainer: '.events__event-slider-controls',
        loop: false,
        items: 3,
        gutter: 0,
        nav: false,
        speed: 600,
        swipeAngle: 45
      },
      video: null
    }
  },

  computed: {
    ...mapGetters([
      'activePage',
      'activeSubNavigation'
    ]),

    key () {
      return this.activePage._id
    },

    sidebarContentKey () {
      return this.activePage.label + this.activePage.description
    },

    sidebarNavigationItems () {
      let sidebarNavigationItems = []
      this.activeSubNavigation.forEach(_item => {
        let item = {
          to: `/category/${this.$store.state.route.params.categoryId}/page/${_item.pageId}`,
          label: _item.label,
          icon: _item.icon
        }
        sidebarNavigationItems.push(item)
      })
      return sidebarNavigationItems
    },    

    sidebarNavigationKey () {
      return JSON.stringify(this.activeSubNavigation)
    },

    language () {
      return this.$store.getters.language
    } 
  },

  mounted () {
    this.$nextTick(() => {
      if (document.querySelectorAll('.video')) {
        const videos = document.querySelectorAll('.video')
        videos.forEach(video => {
          video.muted = true
          video.play()
        })
      }
    })
  },

  methods: {
    convertToThumbnail (path) {
      const paths = path.split('/')
      if (path.substring(path.lastIndexOf('.') + 1, path.length) == 'mp4') {
        return paths[0] + '/thumb_' + paths[1] + '.jpg'
      } else {
        return paths[0] + '/thumb_' + paths[1]
      }
    },

    getSlideFileType (url) {
      const filetype = url.substring(url.lastIndexOf('.') + 1, url.length)

      if (['mp4', 'mov'].indexOf(filetype) !== -1) {
        return 'video'
      } else {
        return 'image'
      }
    },

    handleSliderDrag () {
      this.isSliderDragging = true
      if (this.dragTimeout === null) {
        this.dragTimeout = setTimeout(() => {
          this.dragTimeout = null
          this.isSliderDragging = false
        }, 1000) 
      }
    },

    handleSliderDragEnd () {
      this.dragTimeout = null
      this.isSliderDragging = false
    },

    isVideo (path) {
      if (path.substring(path.lastIndexOf('.')+1, path.length) == 'mp4') {
        return true
      } else {
        return false
      }
    },

    setVideo (video) {
      if (!this.isSliderDragging && video) {
        this.video = video
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "node_modules/tiny-slider/src/tiny-slider";

.events {

  .background--show {
    opacity: 1;
    transition: opacity 1s;
  }

  .background--hide {
    opacity: 0;
    transition: opacity 1s;
  }

  &__background {
    width: 100%;
    position: relative;

    &-heading {
      font-family: 'Canela';
      font-size: 10rem;
      font-weight: 400;
      color: $white;
      position: absolute;
      top: 5rem;
      left: 5rem;
      letter-spacing: 0.05em;
      line-height: 1;
      padding-top: 2rem;
      text-shadow: 0px 0px 5px rgba($black, 0.5);

      .ar & {
        font-family: 'GE Hili';
      }       

      &:before {
        content: '';
        width: 20rem;
        height: 1.5rem;
        background-color: $lblue;
        position: absolute;
        top: 0;
        left: 0.7rem;
      }
    }

    & .video {
      height: 77rem;
      object-fit: contain;
      width: 152rem;
    }

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  &__event-slider-controls {
    color: $gold;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 2.75rem 0 4.25rem;

    div {
      transition: opacity 0.3s;

      &[aria-disabled=true] {
        opacity: 0.2;
      }
    }
  }  

  &__event-slider {
    background: $white;
    bottom: 0;
    position: absolute;
    width: 152rem;
    height: 23.25rem;
    padding: 2.35rem 8rem 2.4rem 9.8rem;

    .tns-item {
      opacity: 0;
      transition: opacity .3s .3s;

      &.tns-slide-active {
        opacity: 1;
        transition: opacity .3s;
      }
    }

    .slide {
      display: flex;
      padding: 0 2rem;

      &--reverse {
        flex-direction: row-reverse;

        .slide__content {
          padding: 0 1rem 0 0;
        }
      }

      &__image-wrapper, &__content {
        position: relative;
        width: 50%;
      }

      &__image-reference {
        background-color: #000;
        border-radius: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.5em;
        font-size: 1.5rem;
        position: absolute;
        top: 0;
        left: 0;
        height: 3rem;
        width: 3rem;
      }

      &__video-circle-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          height: 10rem;
          opacity: .9;
          transition: transform 0.3s;
          width: 10rem;
        }

        &--active {
          svg {
            opacity: 1;
            transform: scale(1.1) rotate(-90deg);
          }
        }
      }

      &__content {
        color: $black;
        padding-left: 1rem;
      }

      &__image {
        height: 18.5rem;
        object-fit: cover;
        width: 20rem;
      }

      &__heading {
        font-family: 'Nexa';
        font-size: 1.4rem;
        font-weight: 400;
        margin-bottom: 0.5em;
        letter-spacing: 0.05em;
        line-height: 1.1;

        .ar & {
          font-family: 'GE Hili';
        }
      }

      &__description {
        font-family: 'Nexa';
        font-size: 1.25rem;
        font-weight: 200;
        line-height: 1.2;
        letter-spacing: 0.05em;

        .ar & {
          font-family: 'GE Dinkum';
        }
      }
    }
  }

  .sidebar__nav-item {
    transition: padding-left 0.3s;
    &.router-link-active, &--active {
      // border-top: 1px solid $lblue;
      // padding-left: 1em;
      color: $bottombar-text-color-active;
    }
  }
}
</style>